import { StringUtils } from '@macs-frontend/web-macs/shared/utils/string';

export class EnumUtils {
  static valuesToArray(enumObj: any, valuesAreNumbers = false): any[] {
    return Object.keys(enumObj)
      .filter((key: string) =>
        valuesAreNumbers ? typeof enumObj[key] === 'number' : true,
      )
      .map((key: string) => {
        // cast value to string in the case the enum value is number
        // eslint-disable-next-line functional/no-let
        let enumValue = enumObj[key] + '';
        enumValue = enumValue.replace(/_/g, ' ');
        return StringUtils.titleCase(enumValue);
      });
  }
}
